import { AppRoute } from '@app/core/routing/AppRoute';
import { DeviceViewPage } from '@app/modules/fleet/legacy/screens/device-view/DeviceViewPage';
import { DevicesListPage } from '@app/modules/fleet/legacy/screens/devices-list/DevicesListPage';
import { UserRole } from '@mi-front/core';
import { Redirect, Route, Switch } from 'react-router-dom';

export function StreamerBoxRoutes() {
  return (
    <Route path="/stream-box">
      <Switch>
        <AppRoute
          allowedRole={[UserRole.CLIENT_ADMIN, UserRole.SUPERADMIN]}
          exact
          path="/stream-box/devices"
          component={DevicesListPage}
        />
        <AppRoute
          allowedRole={[UserRole.CLIENT_ADMIN, UserRole.SUPERADMIN]}
          path="/stream-box/devices/:id"
          component={DeviceViewPage}
        />
        <Redirect to="/stream-box/devices" />
      </Switch>
    </Route>
  );
}
